function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import { camelize, wrapDisplayName } from './utils';
/**
 * A function that returns a React HOC that provides a toggle value and toggle function to the wrapped component.
 * For each toggle name given, the wrapped component will receive the following props:
 *
 * `<toggleName>`: a boolean with the current state of the toggle value, default = false.
 *
 * `set<ToggleName>`: a function that will set the toggle value to a given boolean value.
 *
 * `toggle<ToggleName>`: a function that will toggle the toggle value.
 *
 * Toggle also exposes a `togglePropTypes` function to automatically generate PropTypes for these props.
 * 
 * @param {String|Array} toggleNames - One or more toggle names.
 * @returns {Function} - A HOC that can be used to wrap a component.
 *
 *
 * @example
 *
 * function ComponentWithTooltip ({ message, tooltipShown, toggleTooltipShown }) {
 *   return (
 *     <div>
 *       <button onClick={ toggleTooltipShown }>Click Me</button>
 *       { 
 *         tooltipShown &&
 *         <div className="tooltip">
 *           { message }
 *         </div>
 *       }
 *     </div>
 *   )
 * }
 * 
 * ComponentWithTooltip.propTypes = {
 *   ...togglePropTypes('tooltipShown'),
 *   message: PropTypes.string.isRequired,
 * }
 * 
 * export default compose(
 *   toggle('tooltopShown')
 * )(ComponentWithTooltip)
 * 
*/

export default function toggle() {
  var toggleNames = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var toggles = Array.isArray(toggleNames) ? toggleNames : [toggleNames];
  return function (WrappedComponent) {
    var _class, _temp;

    return _temp = _class =
    /*#__PURE__*/
    function (_React$Component) {
      _inherits(Toggle, _React$Component);

      /*
       * A friendly name for React devtools and errors
       */

      /*
       * A reference to the wrapped component
       */
      function Toggle(props) {
        var _this;

        _classCallCheck(this, Toggle);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(Toggle).call(this, props));
        /*
         * The active state of each toggle
         */

        _this.state = toggles.reduce(function (state, toggle) {
          return _objectSpread({}, state, _defineProperty({}, toggle, false));
        }, {});
        /*
         * The setter functions
         */

        _this.setters = toggles.reduce(function (setters, toggle) {
          return _objectSpread({}, setters, _defineProperty({}, setterFuncName(toggle), function (val) {
            return _this.set.bind(_assertThisInitialized(_this), toggle, val)();
          }));
        }, {});
        /*
         * The toggle functions
         */

        _this.toggles = toggles.reduce(function (togglers, toggle) {
          return _objectSpread({}, togglers, _defineProperty({}, toggleFuncName(toggle), _this.toggle.bind(_assertThisInitialized(_this), toggle)));
        }, {});
        return _this;
      }
      /*
       * Set the active state for the provided toggle name
       */


      _createClass(Toggle, [{
        key: "set",
        value: function set(toggleName, val) {
          if (typeof val !== 'boolean') throw new Error('Toggle can only be set to a boolean value.');
          this.setState(_defineProperty({}, toggleName, val));
        }
        /*
         * Toggle the active state for the provided toggle name
         */

      }, {
        key: "toggle",
        value: function toggle(toggleName) {
          this.setState(function (prevState) {
            return _objectSpread({}, prevState, _defineProperty({}, toggleName, !prevState[toggleName]));
          });
        }
        /*
         * Render the wrapped component with provided props, the active states of
         * the toggles and the toggle functions.
         */

      }, {
        key: "render",
        value: function render() {
          return React.createElement(WrappedComponent, _extends({}, this.props, this.state, this.setters, this.toggles));
        }
      }]);

      return Toggle;
    }(React.Component), _defineProperty(_class, "displayName", wrapDisplayName(WrappedComponent, 'toggle')), _defineProperty(_class, "WrappedComponent", WrappedComponent), _temp;
  };
}

function setterFuncName(toggle) {
  return camelize(['set', toggle].join(' '));
}

function toggleFuncName(toggle) {
  return camelize(['toggle', toggle].join(' '));
}

export function togglePropTypes() {
  var toggleNames = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var toggles = Array.isArray(toggleNames) ? toggleNames : [toggleNames];
  var propTypes = {};
  toggles.forEach(function (toggle) {
    propTypes[toggle] = PropTypes.bool;
    propTypes[setterFuncName(toggle)] = PropTypes.func;
    propTypes[toggleFuncName(toggle)] = PropTypes.func;
  });
  return propTypes;
}